<template>
  <section class="topup">
    <div class="container">
      <div class="topup">
        <h5><b>Instant Recharge</b></h5>
        <form method="POST" @submit.prevent="topUp">
          <div class="form-row">
            <div class="form-group col-md-3">
              <label>Mobile Number</label>
              <p class="control has-icon has-icon-right">
                <input name="mobile" v-validate="'required|min:11|max:11'" v-model="mobile"
                       :class="{'input': true, 'is-danger': errors.has('mobile') }" class="form-control" type="text"
                       placeholder="Mobile Number. Ex: 017********">
                <i v-show="errors.has('mobile')" class="fa fa-warning"></i>
                <span v-show="errors.has('mobile')" class="help is-danger">{{ errors.first('mobile') }}</span>
              </p>
            </div>
            <div class="form-group col-md-3">
              <label>Operator</label>
              <select name="operator" v-model="operator" v-validate="'required'" class="form-control">
                <option value="">Select</option>
                <option value="gp">Grameenphone</option>
                <option value="robi">Robi</option>
                <option value="bl">Banglalink</option>
                <option value="teletalk">Teletalk</option>
                <option value="airtel">Airtel</option>
                <option value="gpskitto">GP Skitto</option>
              </select>
              <i v-show="errors.has('operator')" class="fa fa-warning"></i>
              <span v-show="errors.has('operator')" class="help is-danger">{{ errors.first('operator') }}</span>
            </div>
            <div class="form-group col-md-3">
              <label>Connection Type</label>
              <select name="type" v-validate="'required'" v-model="type" class="form-control">
                <option value="">Select</option>
                <option value="prepaid">Prepaid</option>
                <option value="postpaid">Postpaid</option>
              </select>
              <i v-show="errors.has('type')" class="fa fa-warning"></i>
              <span v-show="errors.has('type')" class="help is-danger">{{ errors.first('type') }}</span>
            </div>
            <div class="form-group col-md-3">
              <label>Amount</label>
              <p class="control has-icon has-icon-right">
                <input name="amount" v-validate="'required|amount:10|numeric'" v-model="amount"
                       :class="{'input': true, 'is-danger': errors.has('amount') }" class="form-control" min="1"
                       type="number" placeholder="Amount">
                <i v-show="errors.has('amount')" class="fa fa-warning"></i>
                <span v-show="errors.has('amount')" class="help is-danger">{{ errors.first('amount') }}</span>
              </p>
            </div>
          </div>
          <div class="send-request">
            <button class="btn btn-primary send-button" type="submit">Proceed To Payment</button>
          </div>
        </form>
      </div>
    </div>
    <PopularPackages/>
  </section>
</template>

<script>
// import axios from "axios";
import {Validator} from 'vee-validate'
import PopularPackages from "./PopularPackages";

export default {
  name: "TopUp",
  components: {PopularPackages},
  data() {
    return {
      mobile: '',
      operator: '',
      type: '',
      amount: ''
    }
  },
  computed: {
    setOperator() {
      return this.$store.state.operator
    },
    setType() {
      return this.$store.state.connectionType;
    },
    setAmount() {
      return this.$store.state.amount;
    }
  },
  watch: {
    '$store.state.connectionType': function () {
      this.type = this.$store.state.connectionType
    },
    '$store.state.amount': function () {
      this.amount = this.$store.state.amount
    },
    '$store.state.operator': function () {
      this.operator = this.$store.state.operator
    }
  },
  mounted() {
    Validator.extend('amount', {
      getMessage: (field, [args]) => `The ${field} must be greater or equal to ${args} BDT`,
      validate: (value, [args]) => parseInt(value) >= parseInt(args) && parseInt(value) > 0
    });
  },
  methods: {
    topUp() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let instance = this;
          let access_token = localStorage.getItem('access_token');
          if (access_token == null) {
            this.$store.commit('showModal', true);
          } else {
            // axios.post(`${this.apiPath}single-topup-client`, {
            //   'mobile': this.mobile,
            //   'operator': this.operator,
            //   'type': this.type,
            //   'amount': this.amount
            // }).then(function (response) {
            //   console.log(response)
            // }.bind()).catch(function (error) {
            //   console.log(error)
            // });
            this.$store.commit('setMobile', instance.mobile);
            this.$store.commit('setOperator', instance.operator);
            this.$store.commit('setConnectionType', instance.type);
            this.$store.commit('setAmount', instance.amount);
            instance.$router.push('/payment');
          }
        }
      });
    }
  }
}
</script>

<style scoped>
.topup {
  padding: 0 10px;
  background: #fff4f9;
  border-radius: 15px;
  margin-bottom: 50px;
}

h5 {
  color: #3d4144;
  margin-bottom: 20px;
}

label {
  color: #55575a;
  font-weight: bold;
}

.control {
  margin-bottom: 0;
}

.is-danger {
  color: #f12e2e;
}

.send-request {
  margin: 0 0 10px 0;
}

.send-button {
  background: #8f2d56;
  border: 1px solid #8f2d56;
}
.topup input, select {
  border: 1px solid #f1cbdb !important;
}
</style>